import { handleActions, combineActions } from 'redux-actions';
import { fromJS, Map } from 'immutable';

import actions from '../actions';

const { loyalty: loyaltyActions } = actions.customer;

export default handleActions(
  {
    [loyaltyActions.getDescriptiveAsync.toString()]: (hotels, { payload }) => {
      return hotels.set("descriptives", hotels.get("descriptives", Map()).merge(payload));
    },
    [combineActions(
      loyaltyActions.update.toString(), 
      loyaltyActions.get.toString())
    ]: (loyalty, { payload }) => {
      return loyalty.set("user", fromJS(payload));
    },
    [loyaltyActions.loyaltyAsync.toString()]: (loyalty, { payload }) => {
      const loy = fromJS(payload);
      return loyalty.set("data", loy?.size ? loy: null);
    },
    [loyaltyActions.getUserAsync.toString()]: (loyalty, { payload }) => {
      return loyalty.set("user", fromJS(payload));
    }
  },
  Map()
);
